var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconAddCircle48Line = function SvgIconAddCircle48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.784 12.18a16.69 16.69 0 1 0 0 23.62 16.72 16.72 0 0 0 0-23.62Zm-2.41 21.21a13.3 13.3 0 1 1 0-18.81 13.31 13.31 0 0 1 0 18.81Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.675 14.99h-3.4v7.3h-7.3v3.4h7.3v7.3h3.4v-7.3h7.3v-3.4h-7.3v-7.3Z",
    fill: "current"
  })));
};
export default SvgIconAddCircle48Line;